import request from '@/http/request';

export function getServerMoveList(data) {
    return request({
      url: '/api/v1/ops/get_serverMove_alltk_info',
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

export function UpdateServerMoveList(data) {
    return request({
      url: '/api/v1/ops/update_serverMove_alltk_info',
      method: 'post',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }